import styled from 'styled-components'

export default styled.input`
  font-size: 13px;
  padding: 10px;
  &:focus {
    outline: none;
  }
`
